module.exports = __webpack_public_path__ + "media/images/dividend/ill-bike-mobile@2x-f6bf968387e532d30f5bfce67e65c1f3.png";